// extracted by mini-css-extract-plugin
export default {"timelineHolder":"Timeline_timelineHolder__6NM70","timelineGrid":"Timeline_timelineGrid__yYOgL"};